<template lang="pug">
  div.staff-management.employees
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :showViewPanel="false"
      :hideImportBtn="true"
    )
      div(slot="filter").horizontal
        div.filter-block
          label Должность
          e-select(
            name="staff_position_id"
            :model="filterModel"
            :options="employeePositions"
            hide-placeholder
            @change="applyFilter"
          )

    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
    )

    router-view
</template>

<script>
  import {transport} from '../../api/api-endpoints.js'
  import tableMixin from '../../components/table/table-mixin.js'
  import {core} from '../../api/api-endpoints'

  export default {
    mixins: [tableMixin],
    data () {
      return {
        filterModel: {
          staff_position_id: ''
        }
      }
    },
    computed: {
      collections () {
        return this.$store.getters.readUrlEndpoint(
          this.getCollectionEndpoint()
        ) || {}
      },
      employeePositions () {
        return [{id: '', name: 'Все'}].concat(this.collections.staff_position)
      },
    },
    methods: {
      getCollectionEndpoint() {
        return core.collection('staff_position')
      },
      getEndpoint (route) {
        return transport.staff(route)
      },
      getDeleteUrl (id) {
        return transport.employee(id)
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []

      if (methods.getEndpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getEndpoint(route)}))
      }

      if (methods.getCollectionEndpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getCollectionEndpoint()}))
      }
      if (promises.length === 0) {
        return Promise.resolve(1)
      }
      return Promise.all(promises)
    }
  }
</script>
